import { Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import { useAlert } from 'react-alert';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import LockIcon from '@mui/icons-material/Lock';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import PauseIcon from '@mui/icons-material/Pause';
import DoneIcon from '@mui/icons-material/Done';
import SendIcon from '@mui/icons-material/Send';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import EuroIcon from '@mui/icons-material/Euro';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import CloseIcon from '@mui/icons-material/Close';
import MessageIcon from '@mui/icons-material/Message';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import moment from 'moment';
import { logError } from '../../components/Utils/FormatData';
import HistoryFilter from '../../components/Dossier/HistoryFilter';
import { CalendarMonthRounded } from '@mui/icons-material';
import { PLANIFICATION_STATUS, PROFIL, REQUEST_PASS_STATUS } from '../../constants/enum';

const css = {
  container: { height: '85%', width: '85%', backgroundColor: 'white', borderRadius: '5px' },
  fullRow: { height: '100%', width: '100%', alignItems: 'center' },
  row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
  rowValidation: { height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end' },
  filterContainer: {
    height: 'fit-content',
    backgroundColor: 'orange',
    padding: '25px',
    margin: '10px',
    fontWeight: 'bold',
    position: 'absolute',
    zIndex: '99',
  },
  filterContent: { display: 'flex', flexDirection: 'column', gap: '15px' },
  filterItem: { cursor: 'pointer' },
};

const statusList = [
  { label: 'Nouveau', value: PLANIFICATION_STATUS.NEW },
  { label: 'Accepté prévisionnel', value: PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL },
  { label: 'Accepté centre', value: PLANIFICATION_STATUS.ACCEPTED_CENTER },
  { label: 'Confirmé client', value: PLANIFICATION_STATUS.CONFIRMED_CLIENT },
  { label: 'Confirmé centres', value: PLANIFICATION_STATUS.CONFIRMED_CENTERS },
  { label: 'Accord émis', value: PLANIFICATION_STATUS.AGREEMENT_ISSUED },
  { label: 'Passage effectué', value: PLANIFICATION_STATUS.PASSAGE_MADE },
  { label: 'Non effectué', value: PLANIFICATION_STATUS.NOT_DONE },
  { label: 'Annulé', value: PLANIFICATION_STATUS.CANCELLED },
  { label: 'Refusé', value: PLANIFICATION_STATUS.REFUSED },
];

const ModalViewDetails = (props) => {
  const { openModal, setOpenModal, color, dossier, user, profil } = props;
  const alert = useAlert();
  const [isLoading, setIsLoading] = useState(true);
  const [listHistory, setListHistory] = useState([]);
  const [baseListHistory, setBaseListHistory] = useState([]);
  const filters = [
    { id: 1, name: 'Note', statusTarget: [99] },
    { id: 2, name: 'Dossier', statusTarget: [1, 2, 6, 14, 98] },
    { id: 3, name: 'Devis / Facture', statusTarget: [8, 9, 95, 96] },
    {id: 4, name: 'Planification', statusTarget: [97] },
  ];

  if (user.profil.id !== 1 && user.profil.id !== 2) {
    filters.splice(0, 1);
  }

  //#region useEffect

  useEffect(() => {
    if (openModal) {
      getHistorique();
    }
  }, [openModal]);

  useEffect(() => {
    if (listHistory !== []) {
      setIsLoading(false);
    }
  }, [listHistory]);


  //#endregion

  //#region Functions

  const handleCloseModal = () => {
    setIsLoading(false);
    setOpenModal(false);
  };

  const addNotes = (index, id) => {
    if (profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR) {
      const newTimelineItem = {
        id: 0,
        id_tracing: id,
        instructeur_account: { login: user.login },
        request_pass_tracing_notes: [
          {
            id: 0,
            note_account: { login: user.login },
            note_user_id: user.id,
          },
        ],
        id_status: 99,
        update_date: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

      const newListHistory = [...listHistory];
      newListHistory.splice(index + 1, 0, newTimelineItem);
      setListHistory(newListHistory);
    }
  };
  // #endregion

  //#region API
  const saveNote = (e) => {
    e.preventDefault();
    let noteContent = e.target[0].value;
    let idTracing = e.target.target;
    if (noteContent === '' || idTracing === '') {
      return;
    }

    axios({
      method: 'POST',
      url: `${URL_API}/demande-passage-tracing-notes/add-note`,
      data: { id_tracing: idTracing, note: noteContent, note_user_id: user.user_id },
    })
      .then((response) => {
        alert.removeAll();
        alert.success('Note ajoutée avec succès');
        getHistorique();
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  const getStatus = (item, userAction, date, index, id, noteContent, planification) => {
    let numDemand = '';
    if (planification) {
        let currentPlanification = planification.dossier?.planifications.find((planification2) => {
          return planification2.id === planification.id;
        });
        let currentPlanifIndex = planification.dossier?.planifications
          .filter((aPlanification) => aPlanification.deleted === false)
          .sort((a, b) => a.id - b.id)
          .findIndex((aPlanification) => aPlanification.id === planification.id) + 1;

        let nbPlanification = 0;

        if (currentPlanification) {
            nbPlanification = planification.dossier?.metadata.datePassage.nbPassageAller + planification.dossier?.metadata.datePassage.nbPassageRetour;
        }

      numDemand = currentPlanifIndex + '/' + nbPlanification;
    }

    let timeLineItem = (() => {
      switch (item) {
        // Nouveau
        case REQUEST_PASS_STATUS.NEW :
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span'>
                Réception dossier
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#ff0000', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#ff0000', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <MarkAsUnreadIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#ff0000', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier a été reçu et est en attente de traitement</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Bloqué
        case REQUEST_PASS_STATUS.BLOCKED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier bloqué
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#7030a0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#7030a0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <LockIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#7030a0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Dossier bloqué</Typography>
              <Typography>La raison a été communiquée par mail</Typography>
            </TimelineContent>
          </TimelineItem>);
        // En cours
        case REQUEST_PASS_STATUS.ON_GOING:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span'>
                Dossier en cours
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#ffc000', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#ffc000', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <QueryBuilderIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#ffc000', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier est en cours d'examen</Typography>
            </TimelineContent>
          </TimelineItem>);
        // En attente
        case REQUEST_PASS_STATUS.WAITING_INTERN:
        case REQUEST_PASS_STATUS.WAITING_CLIENT:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier en attente
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#7030a0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#7030a0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <PauseIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#7030a0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier est incomplet</Typography>
              <Typography>Le problème a été communiqué par mail</Typography>
              <Typography></Typography>
            </TimelineContent>
          </TimelineItem>);
        // Validé
        case REQUEST_PASS_STATUS.VALIDATED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span'>
                Dossier validé
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b0f0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <DoneIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier a été validé</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Signé
        case REQUEST_PASS_STATUS.SIGNED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Devis signé
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b0f0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <AssignmentTurnedInIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le devis a été accepté et signé</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Accepté
        case REQUEST_PASS_STATUS.ACCEPTED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier accepté
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b0f0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <ThumbUpAltIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier a été accepté</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Facturé
        case REQUEST_PASS_STATUS.BILLED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier facturé
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b050', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b050', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <EuroIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b050', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier est facturé</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Terminé
        case REQUEST_PASS_STATUS.TERMINATED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier terminé
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b050', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b050', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <BeenhereIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b050', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier est terminé</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Refusé
        case REQUEST_PASS_STATUS.REFUSED:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier refusé
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#a6a6a6', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <CloseIcon />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>Le dossier a été refusé</Typography>
            </TimelineContent>
          </TimelineItem>);
        // Devis envoyé
        case 95:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Devis
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#a6a6a6', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <CalendarMonthRounded />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>
                {noteContent}
              </Typography>
            </TimelineContent>
          </TimelineItem>);
        // Acceptation devis
        case 96:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Devis
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#a6a6a6', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <CalendarMonthRounded />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>
                {noteContent}
              </Typography>
            </TimelineContent>
          </TimelineItem>);
        // Changement Planification
        case 97:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Planification changée
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#a6a6a6', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <CalendarMonthRounded />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>
                Le statut de la demande : {numDemand ?? '-'} a changé : {(statusList.find((status) => status.value === noteContent) || {}).label}
              </Typography>
            </TimelineContent>
          </TimelineItem>);
        // Édition dossier
        case 98:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
              <Typography variant='h6' component='span' m='0'>
                Dossier édité
              </Typography><br />
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
              <TimelineDot sx={{ bgcolor: '#00b0f0', cursor: 'pointer' }} onClick={() => addNotes(index, id)}>
                <CalendarMonthRounded />
              </TimelineDot>
              {index === (listHistory.length - 1) ? <></> :
                <TimelineConnector sx={{ bgcolor: '#00b0f0', height: '30px' }} />}
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              <Typography>
                Le dossier a été édité {noteContent && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE)  ? `, Description : ${noteContent}` : ''}
              </Typography>
            </TimelineContent>
          </TimelineItem>);
        // Note
        case 99:
          return (<TimelineItem key={index} item={item} sx={{ minHeight: 'auto' }}>
            <TimelineOppositeContent sx={{ m: 'auto' }} align='right' variant='body2'>
              {userAction} <br />
              {moment(date).format('DD/MM/YYYY à HH:mm')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />
              <TimelineDot sx={{ bgcolor: '#a6a6a6' }}>
                <MessageIcon />
              </TimelineDot>
              <TimelineConnector sx={{ bgcolor: '#a6a6a6', height: '30px' }} />
            </TimelineSeparator>
            <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
              {id === 0 ?
                <>
                  <form onSubmit={saveNote} target={listHistory[index].id_tracing}>
                    <TextField
                      label=''
                      type='text'
                      name='note'
                      style={{ margin: '0px', marginBottom: '10px', width: '70%' }}
                      autoComplete='off'
                      fullWidth={false}
                      multiline
                      rows={2}
                      inputProps={{ maxLength: 255 }}
                    />
                    <br />
                    <MyButton type='submit' style='buttonValidationNoMargin' label={'Envoyer'} />
                  </form>
                </>
                : noteContent}
            </TimelineContent>
          </TimelineItem>);
        default :
          return null;
      }
    })();

    if (listHistory[index].request_pass_tracing_notes && listHistory[index].request_pass_tracing_notes.length !== 0 && item !== 99) {
      let notes = listHistory[index].request_pass_tracing_notes;
      notes.map((note) => {
        let noteTimeLineItem = getStatus(99, note.note_account.login, note.note_date, index, 1, note.note);
        timeLineItem = [timeLineItem, noteTimeLineItem];
        return note;
      });
    }

    return timeLineItem;
  };

  const hideStatus = (statusTarget) => {
    if (statusTarget === '*') {
      setListHistory(baseListHistory);
      return;
    }

    let list = baseListHistory;
    list = list.filter((item) => {
      if (statusTarget.includes(99) && item.request_pass_tracing_notes && item.request_pass_tracing_notes.length !== 0) {
        return true;
      }
      return statusTarget.includes(item.id_status);
    });
    setListHistory(list);
  };
  //#endregion

  //#region API

  const getHistorique = () => {
    axios({
      method: 'GET',
      url: `${URL_API}/demande-passage-tracing/history-by-request-pass-id`,
      params: { 'id': dossier.id, userAction: user.user_id },
    })
      .then((response) => {
        alert.removeAll();
        setListHistory(response.data);
        setBaseListHistory(response.data);
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  //#endregion

  //#region Render

  return (<>
    <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
      <div className='modal'>
        <div style={css.container}>
          <TopBar title={`Historique du dossier [N°${dossier.id}]`} className='topbar-contenu' color={color}
                  buttons={<div className='topbar-buttons'>
                    <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#839d3c !important'}} />
                  </div>}
          />

          {isLoading && <div className='row' style={css.fullRow}>
            <ClipLoader color='#0094ca' loading={isLoading} size={75}
                        css={'display: flex; margin: 25px;justify-content: center;'} />
          </div>}

          {!isLoading && <div className='row' style={{
            flexWrap: 'nowrap',
            justifyContent: 'left',
            maxHeight: '90%',
            height: 'fit-content',
            overflowY: 'auto',
          }}>
            <HistoryFilter
              title={'Filtres :'}
              listFilters={filters}
              onClickFilter={(e) => hideStatus(e)}
            />
            <Timeline>
              {listHistory.map((element, index) => {
                return (getStatus(element.id_status, element.instructeur_account.login, element.update_date, index, element.id, element.description, element.planification));
              })}
            </Timeline>
          </div>}
        </div>
      </div>
    </Modal>
  </>);

  //#endregion

};

export default ModalViewDetails;
